import React, { useEffect, useState } from 'react';
import { useNotifications } from '../contexts/NotificationContext';
import { useAuth } from '../auth/AuthContext';

/**
 * Component to handle promotional notifications
 * Checks for promotions and sends notifications
 */
const PromotionalNotifications = () => {
  const { notifyPromotion, isEnabled } = useNotifications();
  const { user, isAuthenticated } = useAuth();
  const [lastPromotionCheck, setLastPromotionCheck] = useState(null);

  useEffect(() => {
    if (!isEnabled || !isAuthenticated) return;

    // Check for promotions every hour
    const checkPromotions = async () => {
      const now = Date.now();
      const lastCheck = localStorage.getItem('lastPromotionCheck');
      
      // Only check once per hour
      if (lastCheck && (now - parseInt(lastCheck)) < 3600000) {
        return;
      }

      try {
        // Simulate checking for promotions (replace with actual API call)
        const promotions = [
          {
            id: 'flash-sale-1',
            title: 'Flash Sale!',
            message: 'Get 20% OFF on all brake parts. Limited time offer!',
            url: '/catalog?category=brake',
            showAfter: 0 // Show immediately if not shown before
          },
          {
            id: 'bulk-discount',
            title: 'Bulk Purchase Bonus',
            message: 'Buy 10+ items and save up to 25%! Shop now.',
            url: '/catalog',
            showAfter: 86400000 // Show after 24 hours
          }
        ];

        for (const promotion of promotions) {
          const lastShown = localStorage.getItem(`promotion-${promotion.id}`);
          
          if (!lastShown || (now - parseInt(lastShown)) >= promotion.showAfter) {
            await notifyPromotion(
              promotion.title,
              promotion.message,
              promotion.id,
              promotion.url
            );
            localStorage.setItem(`promotion-${promotion.id}`, now.toString());
          }
        }

        setLastPromotionCheck(now);
        localStorage.setItem('lastPromotionCheck', now.toString());
      } catch (error) {
        console.error('Error checking promotions:', error);
      }
    };

    // Initial check after 5 minutes of being authenticated
    const initialTimer = setTimeout(() => {
      checkPromotions();
    }, 300000); // 5 minutes

    // Set up interval to check every hour
    const interval = setInterval(checkPromotions, 3600000); // 1 hour

    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, [isEnabled, isAuthenticated, notifyPromotion]);

  return null; // This component doesn't render anything
};

export default PromotionalNotifications;

